import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatVal } from '../../../../helpers/value'
import { Element } from '../../../html/element'

export const DeliveryDays = ({ deliveryDays }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Element elementName="span" style={{ color: '#9C9C9C' }}>
      (
      <Translate value="common.order.businessCreditReport.DELIVERY_TIME" />
      :&nbsp;
      {[
        formatVal(deliveryDays - 1, locale, false, 0),
        formatVal(deliveryDays, locale, false, 0),
      ].join('-')}
      &nbsp;
      <Translate value="common.order.businessCreditReport.DAYS" />)
    </Element>
  )
}
